export const OTP_DIGIT_COUNT = 6

export const normalizeEmailValue = (value = '') => value.trim().toLowerCase()

export const createEmptyOtpDigits = () =>
  Array.from({ length: OTP_DIGIT_COUNT }, () => '')

export const formatCountdown = (seconds) => {
  const safeSeconds = Math.max(0, Number(seconds) || 0)
  const minutes = Math.floor(safeSeconds / 60)
  const remainingSeconds = safeSeconds % 60
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`
}

export const maskEmailForDisplay = (email) => {
  const normalizedEmail = normalizeEmailValue(email || '')
  const atIndex = normalizedEmail.indexOf('@')
  if (atIndex <= 1) {
    return normalizedEmail
      ? `***${normalizedEmail.slice(Math.max(atIndex, 0))}`
      : ''
  }
  return `${normalizedEmail.slice(0, 2)}***${normalizedEmail.slice(atIndex)}`
}

export const extractBackendError = (err) => {
  const data = err.response?.data
  if (!data) return null
  if (typeof data === 'string') return data
  if (typeof data.error === 'string' && data.error.trim()) return data.error
  if (typeof data.message === 'string' && data.message.trim()) return data.message
  if (typeof data === 'object') {
    const firstValue = Object.values(data).find(
      (value) => typeof value === 'string' && value.trim()
    )
    if (typeof firstValue === 'string') return firstValue
  }
  return null
}
